<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <tableList ref="multipleTable" :table-query="search" :query-function="queryFunction" :deal-data="dealData" size="small" style="width: 100%">
      <el-table-column prop="id" label="活动ID" width="80" fixed />
      <el-table-column prop="title" label="活动标题" />
      <el-table-column prop="cityName" label="城市" />
      <el-table-column prop="beginTime" label="活动开始日期" />
      <el-table-column prop="status" label="活动状态">
        <template slot-scope="scope">
          <span class="activity-status-tag" :style="activityStatus[scope.row.status].style">{{ scope.row.statusName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="combineModeName" label="赛事类型" width="120" />
      <el-table-column prop="createTime" label="创建时间" />
      <el-table-column fixed="right" width="250px" label="操作">
        <template slot-scope="{row}">
          <el-button size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="text" class="link-color" @click="copy(row)">复制</el-button>
          <el-button v-if="row.status === 0" size="small" type="text" class="link-color" @click="publish(row)">发布</el-button>
          <el-button v-if="row.status !== 0" size="small" type="text" class="link-color" @click="offShelf(row)">下架</el-button>
          <el-button size="small" type="text" class="link-color" @click="copyLink(row)">复制链接</el-button>
          <el-popover v-if="row.status !== 2" placement="bottom" width="148" trigger="click" :popper-options="{ removeOnDestroy: true }">
            <div style="text-align:center">
              <img :ref="`personalQr${row.id}`" src="" alt="" style="width:100%;">
              <el-button size="small" type="text" class="link-color" @click="downQrCode(row, 'personal')">下载二维码</el-button>
            </div>
            <el-button slot="reference" size="small" type="text" class="link-color" @click="getCheckCode(row, 1)">个人赛签到码</el-button>
          </el-popover>
          <el-popover v-if="row.status !== 2" placement="bottom" width="148" trigger="click" :popper-options="{ removeOnDestroy: true }">
            <div style="text-align:center">
              <img :ref="`teamQr${row.id}`" src="" alt="" style="width:100%;">
              <el-button size="small" type="text" class="link-color" @click="downQrCode(row, 'team')">下载二维码</el-button>
            </div>
            <el-button slot="reference" size="small" type="text" class="link-color" @click="getCheckCode(row, 2)">团体赛签到码</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </tableList>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import Dialog from '@/components/Dialog';
import { mainActivityList, publishMainActivity, offlineMainActivity, generateCheckCode, copyActivityLink } from '@/api/combine';

export default {
  components: { tableList, Dialog },
  data() {
    const activityStatus = [
      { id: 0, value: '草稿', style: 'background: #EA99211A; border: 1px solid #EA9921B2; color: #EA9921;' },
      { id: 1, value: '进行中', style: 'background: #1890FF1A; border: 1px solid #1890FFB2; color: #1890FF;' },
      { id: 2, value: '已结束', style: 'background: #4949491A; border: 1px solid #9B9B9BB2; color: #9B9B9B;' },
    ];
    return {
      search: {},
      activityStatus,
      formDialogShow: false,
      currentID: -1,
      information: [],
      currentPage: 1,
      pageSize: 10,
      queryFunction: mainActivityList,
    };
  },
  computed: {
    totalRecords() {
      return this.$refs.multipleTable?.paginationParams?.total || 0;
    },
  },
  activated() {
    this.$refs.multipleTable.getTableList();
  },
  methods: {
    dealData(res) {
      if (res?.length) {
        res.forEach(item => {
          item.beginTime && (item.beginTime = this.$moment(item.beginTime).format('YYYY.MM.DD'));
          item.createTime && (item.createTime = this.$moment(item.createTime).format('YYYY/MM/DD HH:mm:ss'));
        });
      }
      return res;
    },
    add() {
      this.$router.push({ path: '/nextCombine/mainActivity/add' });
    },
    edit(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      let subTitle = '';
      switch (row.status) {
        case 0:
          subTitle = `是否确认编辑活动ID为"${row.id}"的数据项？`;
          break;
        case 1:
          subTitle = `活动进行中，编辑活动ID为"${row.id}"的数据将会更新活动信息，是否继续？`;
          break;
        case 2:
          subTitle = `活动已结束，编辑活动ID为"${row.id}"的数据将会更新活动信息，是否继续？`;
          break;
        default:
          break;
      }
      this.information = { operation: 'edit', icon: 'warn', subTitle };
    },
    remove(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '删除后小程序用户将无法查看该活动，请确认是否删除',
      };
    },
    copy(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'copy',
        icon: 'success',
        subTitle: `复制成功！是否进入新增页面？`,
      };
    },
    submitSucces(operation) {
      if (operation === 'delete') {
        // TODO: 后续对接删除API
        this.formDialogShow = false;
        this.$message.success('删除成功');
        const tableData = this.$refs['multipleTable'].$data.tableData || [];
        const currentPage = this.$refs['multipleTable'].paginationParams.current;
        if (tableData.length === 1 && currentPage > 1) {
          this.$refs['multipleTable'].paginationParams.current = currentPage - 1;
        }
        this.$refs['multipleTable'].getTableList();
      } else if (operation === 'copy') {
        this.$router.push({ path: '/nextCombine/mainActivity/add', query: { copyid: this.currentID } });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/nextCombine/mainActivity/edit', query: { id: this.currentID } });
      } else if (operation === 'publish') {
        this.formDialogShow = false;
        publishMainActivity(this.currentID).then(() => {
          this.$message.success('发布成功');
          this.$refs['multipleTable'].getTableList();
        });
      } else if (operation === 'offShelf') {
        this.formDialogShow = false;
        offlineMainActivity(this.currentID).then(() => {
          this.$message.success('下架成功');
          this.$refs['multipleTable'].getTableList();
        });
      }
    },
    publish(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'publish',
        icon: 'warn',
        subTitle: `是否确认发布活动ID为"${row.id}"的数据项？`,
      };
    },
    offShelf(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'offShelf',
        icon: 'warn',
        subTitle: `是否确认下架活动ID为"${row.id}"的数据项？`,
      };
    },
    copyLink(row) {
      copyActivityLink(row.id).then(res => {
        const text = typeof res === 'string' ? res : (res.link || res.url || '');
        if (text) {
          navigator.clipboard.writeText(text).then(() => {
            this.$message.success('复制链接成功');
          }).catch(() => {
            this.$message.error('复制失败，请手动复制');
          });
        }
      });
    },
    getCheckCode(row, subType) {
      generateCheckCode(row.id, subType).then(res => {
        console.log("res++", res);
        const refKey = subType === 1 ? `personalQr${row.id}` : `teamQr${row.id}`;
        this.$refs[refKey].src = res;
      });
    },
    downQrCode(row, type) {
      const refKey = type === 'personal' ? `personalQr${row.id}` : `teamQr${row.id}`;
      const link = document.createElement('a');
      link.href = this.$refs[refKey].src;
      link.download = `${row.title}_${type === 'personal' ? '个人赛签到码' : '团体赛签到码'}.png`;
      link.target = '_blank';
      link.click();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.$refs.multipleTable.paginationParams.size = val;
      this.$refs.multipleTable.getTableList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$refs.multipleTable.paginationParams.current = val;
      this.$refs.multipleTable.getTableList();
    },
  },
};
</script>
<style scoped lang="less">
.activity-status-tag {
  display: inline-block;
  min-width: 100px;
  height: 22px;
  line-height: 22px;
  padding: 0 8px;
  border-radius: 0;
  font-size: 14px;
  text-align: center;
}
</style>
